module.exports = __webpack_public_path__ + "img/20240702074234988izo.7613b9bc.jpg";